import React from 'react'

import BookingPlugin from '../containers/plugin/booking-plugin'
import LeaguesPlugin from '../containers/plugin/leagues-plugin'
import LeaguePlugin from '../containers/plugin/league-plugin'
import RegistrationPlugin from '../containers/plugin/registration-plugin'

const pluginComponents = type => {
  switch (type) {
    case 'BOOKING_PLUGIN': return <BookingPlugin />
    case 'LEAGUES_PLUGIN': return <LeaguesPlugin />
    case 'LEAGUE_PLUGIN': return <LeaguePlugin />
    case 'REGISTRATION_PLUGIN': return <RegistrationPlugin />
  }
}

export default pluginComponents
